var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.allowDebug === true ? _c('ul', {
    staticClass: "supporting-apps"
  }, [_c('li', [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.changeMode('tester');
      }
    }
  }, [_vm._v("Activity Tester")])]), _vm._m(0), _c('li', [_c('router-link', {
    attrs: {
      "to": "/unsupported"
    }
  }, [_vm._v("Unsupported Screen")])], 1)]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "preview.html?nid=542"
    }
  }, [_vm._v("Free Demo/Lesson Preview")])]);
}]

export { render, staticRenderFns }